import { render, staticRenderFns } from "./AddStrategyForm.vue?vue&type=template&id=2b0e8087&scoped=true&"
import script from "./AddStrategyForm.vue?vue&type=script&lang=js&"
export * from "./AddStrategyForm.vue?vue&type=script&lang=js&"
import style0 from "./AddStrategyForm.vue?vue&type=style&index=0&id=2b0e8087&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e8087",
  null
  
)

export default component.exports